import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MojoShareResourceModule } from 'mojo-share-resource';

import {
  AVATAR_CONFIG_SERVICE,
  AVATAR_DOWNLOAD_SERVICE,
} from '@core/injection-tokens/avatar.injection.token';
import {
  SHARE_RESOURCE_AUTOCOMPLETE_SERVICE,
  SHARE_RESOURCE_SERVICE,
  SHARE_TEAM_MEMBER_SERVICE,
} from '@core/injection-tokens/share-resource.injection.token';
import { MaterialModule } from '@material/material.module';
import { TeamMembersModalService } from '@shared/modal/team-members/team-members-modal.service';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    MojoShareResourceModule.forRoot(
      SHARE_RESOURCE_SERVICE,
      SHARE_RESOURCE_AUTOCOMPLETE_SERVICE,
      AVATAR_DOWNLOAD_SERVICE,
      AVATAR_CONFIG_SERVICE,
      SHARE_TEAM_MEMBER_SERVICE,
    ),
  ],
})
export class TeamMembersModalModule {
  constructor(private _teamMembersModalService: TeamMembersModalService) {}
}
